import { apiResponseMiddleware } from "@/middleware/api-response";
import axios from "axios";

const API_URL = import.meta.env.VITE_FORM_API_URL as string;
const API_ENDPOINT = "api/Authentication";

interface ForgotPasswordResponse {
  message: string;
}

interface ResetPasswordRequest {
  token: string;
  newPassword: string;
  confirmPassword: string;
}

interface ResetPasswordResponse {
  success: boolean;
  message: string;
}

export const forgotPassword = async (email: string) => {
  return apiResponseMiddleware<ForgotPasswordResponse>(
    axios.post(
      `${API_URL}/${API_ENDPOINT}/forgotPassword`,
      { email },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    ),
    () => {},
    {
      showToast: false
    }
  );
};

export const resetPassword = async (request: ResetPasswordRequest) => {
  return apiResponseMiddleware<ResetPasswordResponse>(
    axios.post(
      `${API_URL}/${API_ENDPOINT}/resetPassword`,
      request,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    ),
    () => {},
    {
      showToast: false
    }
  );
};

export const validateResetToken = async (token: string) => {
  return apiResponseMiddleware<boolean>(
    axios.get(`${API_URL}/${API_ENDPOINT}/validateResetToken/${token}`),
    () => {},
    {
      showToast: false
    }
  );
};
